import React from "react";

/**
 * AdminFooter component represents the footer section of the admin page.
 * It displays copyright information.
 * @component
 * @return {JSX.Element} Footer component for the admin page.
 */
function AdminFooter() {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          {/* Copyright information */}
          <div className="nk-footer-copyright">
            &copy; 2025 Admin. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

// Export the AdminFooter component for use in other modules
export default AdminFooter;
